import prodConfigs from './configs/prodConfigs.json';
import testConfigs from './configs/testConfigs.json';

export default class ConfigRetriever {
  static getConfig(rte: string, site: string) {
    const envConfig = rte.toUpperCase() === 'PROD' ? prodConfigs : testConfigs;
    const config = { ...envConfig.core, ...envConfig[site] };
    return config;
  }
}
